const initialState = {
    adjustmentConfigurationGridRowData: [],
    sourceColumnsForSelectionBox: [],
    workflowRuleNames: [],
    workflowRuleNamesForSelectionBox: [],
    workflowConfigurations: {},
    isAdjustmentConfiguration: false,

};

export default initialState;